import { render, staticRenderFns } from "./ComerciosTable.vue?vue&type=template&id=8ee88bce&lang=pug&"
import script from "./ComerciosTable.vue?vue&type=script&lang=js&"
export * from "./ComerciosTable.vue?vue&type=script&lang=js&"
import style0 from "./ComerciosTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports